import React, { useState, useEffect, createContext, useContext } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { useFlags } from "launchdarkly-react-client-sdk";
import { createUTagPageView } from "../helpers";
import { AppStore } from "../app/store";

const initialState = "";
export const ReferrerContext = createContext(initialState);

const ReferrerDetector: React.FunctionComponent<RouteComponentProps> = ({
  location,
  children,
}) => {
  const { pathname } = location;
  const { state } = useContext(AppStore.AppContext);
  const [previousLocation, setPreviousLocation] = useState("");
  const [goBackTextId, setGoBackTextId] = useState(initialState);
  const flags = useFlags();
  const { mctCurrentPlanYear } = flags;

  useEffect(() => {
    if (previousLocation !== pathname) {
      setPreviousLocation(pathname);

      switch (previousLocation) {
        case "/search-results":
          setGoBackTextId("app.terms.go_back_to_search_results");
          break;
        case "/compare-plans":
          setGoBackTextId("app.terms.go_back_to_plan_compare");
          break;
        default:
          setGoBackTextId("app.terms.start_a_new_search");
          break;
      }
    }

    if (state.tealiumLoaded) {
      createUTagPageView({
        page_name: pathname
          .replace("/", "")
          .split("/", 1)
          .join("")
          .replace(/-/g, " "),
        state,
        location,
        flags,
        mctCurrentPlanYear,
      });
    }
  }, [pathname, state.tealiumLoaded]);

  return (
    <ReferrerContext.Provider value={goBackTextId}>
      {children}
    </ReferrerContext.Provider>
  );
};

export default withRouter(ReferrerDetector);
